
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class BookingOverviewComponent extends Vue {
  @Prop({ default: "" })
  label!: string;

  @Prop({ default: "" })
  value!: string;

  @Prop({ default: false })
  multiLine!: boolean;

  @Prop({ default: false })
  clickable!: boolean;

  @Prop({ default: false })
  highlight!: boolean;

  emitClick() {
    this.$emit("click");
  }
}
